module.exports = __webpack_public_path__ + "static/sedi-white-4d5c34511c2c0756924d2995efe8877b.png";